import { defineMessages } from "react-intl";

export default defineMessages({
  label: {
    id: "taskCreation.prefill.badge",
    defaultMessage: "Auto-filled from your description",
  },
});
